import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AddDocumentComponent } from '@app/modules/vault/components/add-document/add-document.component';
import { SharedConfirmationDialogComponent } from '../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { SelectUserFromNetworkComponent } from '../select-user-from-network/select-user-from-network.component';
import { toBase64 } from '@aws-sdk/util-base64-node';
import moment from 'moment';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { Editor } from 'ngx-editor';
import * as vaultSelectors from '@app/root-store/vault-store/vault.selector';
import * as loginSelector from '../../../root-store/login-store/login.selector';
import { select, Store } from '@ngrx/store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { ChecklistTaskService } from '@app/shared/services/checklist/checklist-task.service';
import { AuthService, CommonService, DocumentService, LoaderService } from '@app/shared/services';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSidenav } from '@angular/material/sidenav';
import * as fileSaver from 'file-saver';
import { CreateAttachemntPopupComponent } from '@app/modules/vault/components/add-document/create-attachemnt-popup/create-attachemnt-popup.component';
import { AddTrustTemplateDialogComponent } from '../add-trust-template-dialog/add-trust-template-dialog.component';
import { AddTrustTemplate } from '../add-trust-template-dialog/add-trust-template.interfaces';
import { FileUploadedLimitExtension } from '@app/enum/FileTypeListSizeEnum';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
//
import { CheckListTaskAttachmentsComponent } from './check-list-task-attachments/check-list-task-attachments.component';
import { vaultStoreActions } from '@app/root-store';
import { fetchUserAttributes } from '@aws-amplify/auth';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'checklist-task',
  templateUrl: './checklist-task.component.html',
  styleUrl: './checklist-task.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class ChecklistTaskComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('templateAddButton') templateAddButton: ElementRef;
  @ViewChild('templateSearchInput') templateSearchInput: ElementRef;
  @ViewChild('hyperLink') hyperLink: ElementRef;
  @ViewChild(CheckListTaskAttachmentsComponent) CheckListTaskAttachmentsComponent!: CheckListTaskAttachmentsComponent;
  @Input() currentFormId;
  @Input() formLinked;
  @Output() closeSidebarEmitter = new EventEmitter();
  from_data;
  isFormSetupOpen = false;
  isTemplateLinkingOpened = false;
  setupDrawer = false;
  isLinkTemplateModel = false;
  addVaultShortcut: boolean = false;
  mode;
  isCustom;
  groupName;
  taskId;
  screenWidth: number;
  FileUploadedLimitExtension = FileUploadedLimitExtension;
  task_id;
  user;
  ownerUser;
  stateObject;
  currentUserSecurity;
  attachedItems = '';
  files: any = [];
  urlLinks = [];
  iframeLoaded = false;
  showDropDown = false;
  showEditorMenu = false;
  addTemplate = false;
  addTemplatetype = false;
  addHyperlink = false;
  linkedTemplate;
  linkedshortcut;
  linkedTemplateObj;
  linkedTemplatetypeObj;
  linkedHyperlinkObj;
  loadHyperlink = false;
  templatetypeAdded = false;
  templateAdded = false;
  attachedAdded = false;
  AccessTotemplate = false;
  getAccessTotemplate = false;
  isImpersonating: boolean = false;
  isEventInProgress = false;
  vaultStateObject;
  vaultStateObject$: any;
  taskForm: UntypedFormGroup;
  formsList;
  shortcutlist;
  filteredShortcutList: string[] = [];
  taskDetail;
  searchText = '';
  searchTextType = '';
  today = new Date();
  is_form_valid = true;
  ownerlist: boolean = false;
  resizeObservable$: Observable<Event>;
  subscription: Subscription = new Subscription();
  vaultUserID$ = this.store.pipe(select(vaultSelectors.getcurrentVaultUserId()));
  status = [
    {
      key: '1',
      value: 'notstarted',
      displayText: 'Not Started',
      color: '#9B51E0',
      backgroundColor: 'linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), #dea000 !important',
    },
    {
      key: '2',
      value: 'inprogress',
      displayText: 'In Progress',
      color: '#2F80ED',
      backgroundColor: 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2d9cdb !important',
    },
    {
      key: '3',
      value: 'complete',
      displayText: 'Complete',
      color: '#27AE60',
      backgroundColor: 'linear-gradient(0deg, #e9f7ef, #e9f7ef), #2d9cdb !important)',
    },
  ];

  dueWhen = [
    { value: 'asap', displayText: ' ASAP' },
    { value: 'future', displayText: 'On a Future Date' },
  ];

  repeateAfterPeriod = [
    { value: 'months', displayText: 'Month(s)' },
    { value: 'years', displayText: 'Year(s)' },
  ];

  repeateAfterDuration = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

  loginOwnerUserProfile = {
    id: '',
    name: '',
    image: '',
  };

  is_reload = false;
  editor: Editor;
  toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['code', 'blockquote'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  origin = '';
  timeline_type_list = [
    { label: 'Start by Date', value: 'Start by Date' },
    { label: 'Finish by Date', value: 'Finish by Date' },
  ];

  timeline_period_type_list = [
    { label: 'Days', value: 'day' },
    { label: 'Months', value: 'month' },
    { label: 'Years', value: 'year' },
    { label: 'Quarter', value: 'quarter' },
  ];
  timeline_period_list = [];
  loaderItems = [{ id: 1 }];
  isTaskCreator: boolean = false;
  // @HostListener('document:click', ['$event'])
  // onDocumentClick(event: MouseEvent) {
  //   if (
  //     !this.formDropdown.nativeElement.contains(event.target) &&
  //     !this.templateAddButton.nativeElement.contains(event.target) &&
  //     !this.templateSearchInput.nativeElement.contains(event.target)
  //   ) {
  //     this.showDropDown = false;
  //   }
  // }

  constructor(
    private dialogRef: MatDialogRef<ChecklistTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private vaultService: VaultStoreEffects,
    private _fb: UntypedFormBuilder,
    private store: Store,
    private router: Router,
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService,
    private commonService: CommonService,
    private loginService: LoginStoreEffects,
    private loaderService: LoaderService,
    private documentService: DocumentService,
    private checklistTaskService: ChecklistTaskService,
    private cryptoService: CryptoService,
    private authService: AuthService
  ) {
    this.task_id = data.taskId;
    this.mode = data.mode;
    this.isCustom = data.isCustom;
    this.groupName = data.groupName;
    this.vaultStateObject$ = this.vaultService.vaultObject;
    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.cd.markForCheck();
      })
    );
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state && state.data) {
          if (state?.data?.id) {
            this.loginOwnerUserProfile.id = state.data.id || '';
            this.loginOwnerUserProfile.image = state.data.profile_image_url || '';
            this.loginOwnerUserProfile.name = state.data.name || '';
          }
          this.user = state.data;
          this.cd.markForCheck();
          this.getAllForms();
        }
      })
    );
    this.subscription.add(
      this.store.pipe(select(loginSelector.getCurrentUserFullDetails)).subscribe(async (result) => {
        try {
          const authUser = this.authService.user;
          if (result?.switch_from_user_id && result?.id != authUser['id']) {
            this.isImpersonating = true;
          } else {
            this.isImpersonating = false;
          }
        } catch (error) {
          // this.toastr.error(error.error.message);
        }
      })
    );
    this.subscription.add(
      this.vaultService.vaultObject.subscribe((state) => {
        this.shortcutlist = state?.forms ? state?.forms : [];
      })
    );
    this.filteredShortcutList = this.shortcutlist;
  }

  addEvent(event, value) {
    this.calculateDate();
  }
  calculateDate() {
    if (
      (this.taskForm.controls.timeline_start_date.value != '' || this.taskForm.controls.timeline_finish_date.value != '') &&
      this.taskForm.controls.timeline_period_type.value != '' &&
      this.taskForm.controls.timeline_period.value != ''
    ) {
      if (this.taskForm.controls.timeline_future_date_is.value == 'Start by Date') {
        let timeline_start_date = this.taskForm.controls.timeline_start_date.value;

        let nextDate = this.commonService.calculateNextDate(
          timeline_start_date,
          this.taskForm.controls.timeline_period.value,
          this.taskForm.controls.timeline_period_type.value,
          true
        );

        if ((nextDate as any) != 'Invalid Date') {
          this.taskForm.controls.timeline_finish_date.setValue(nextDate);
        }
      } else {
        let nextDate = this.commonService.calculateNextDate(
          this.taskForm.controls.timeline_finish_date.value,
          this.taskForm.controls.timeline_period.value,
          this.taskForm.controls.timeline_period_type.value,
          false
        );
        if ((nextDate as any) != 'Invalid Date') {
          this.taskForm.controls.timeline_start_date.setValue(nextDate);
        }
      }
    }
    this.cd.detectChanges();
  }

  setReminderType(item) {
    this.taskForm.controls.taskDueWhen.setValue(item);
  }
  ngOnInit(): void {
    // this.store.dispatch(new vaultStoreActions.DefaultFolderRequest(this.loginOwnerUserProfile.id));
    // this.store.dispatch(new vaultStoreActions.UserFoldersRequest(this.loginOwnerUserProfile.id, true));
    // this.store.dispatch(new vaultStoreActions.UserFoldersSharedWithMeRequest((this.loginOwnerUserProfile.id), true));
    this.store.dispatch(new vaultStoreActions.AdminAccessRequest());
    this.store.dispatch(new vaultStoreActions.FormRequest());
    this.store.dispatch(new vaultStoreActions.CategoriesRequest());
    for (let index = 1; index < 31; index++) {
      this.timeline_period_list.push({
        label: index.toString(),
        value: index.toString(),
      });
    }
    this.editor = new Editor();
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.taskForm = this._fb.group(
      {
        taskName: [''],
        taskDesc: [''],
        hyperLink: [''],
        hyperLinkName: [''],
        taskDueDate: [null],
        taskDueWhen: [this.dueWhen[0].value],
        repeat_task: [false],
        repeat_after_duration: [this.repeateAfterDuration[0]],
        repeat_after_period: [this.repeateAfterPeriod[0].value],
        taskStatusProgress: [this.status[0].value],
        vault_user_form_id: [null],
        start_date: ['ASAP'],
        finish_date: ['ASAP'],
        timeline_start_date: [''],
        timeline_finish_date: [''],
        timeline_future_date_is: ['Start by Date'],
        timeline_period: [''],
        timeline_period_type: [''],
        shortcut: [''],
      },
      {
        validators: [this.checkTaskFormValidation.bind(this)],
      }
    );

    this.subscription.add(
      this.taskForm.controls.timeline_future_date_is.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.taskForm.controls.timeline_period.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    this.subscription.add(
      this.taskForm.controls.timeline_period_type.valueChanges.subscribe((val) => {
        this.calculateDate();
      })
    );
    if (this.mode == 'add') {
      this.getChecklistTaskId();
      if (this.groupName == 'complete' || this.groupName == 'asap' || this.groupName == 'pastDue') {
        this.taskForm.controls['taskDueWhen'].setValue(this.dueWhen[0].value);
      }
      if (this.groupName == 'next7') {
        this.taskForm.controls['taskDueWhen'].patchValue(this.dueWhen[1].value);
        const nextSevenDays = new Date(new Date().setDate(new Date().getDate() + 6));
        this.taskForm.controls['taskDueDate'].patchValue(nextSevenDays);
      }
      if (this.groupName == 'next30') {
        this.taskForm.controls['taskDueWhen'].patchValue(this.dueWhen[1].value);
        const nextThirtyDays = new Date(new Date().setDate(new Date().getDate() + 29));
        this.taskForm.controls['taskDueDate'].patchValue(nextThirtyDays);
      }
      if (this.groupName == 'next90') {
        this.taskForm.controls['taskDueWhen'].patchValue(this.dueWhen[1].value);
        const nextNinetyDays = new Date(new Date().setDate(new Date().getDate() + 89));
        this.taskForm.controls['taskDueDate'].patchValue(nextNinetyDays);
      }
      if (this.groupName == 'more90') {
        this.taskForm.controls['taskDueWhen'].patchValue(this.dueWhen[1].value);
        const moreNinetyDays = new Date(new Date().setDate(new Date().getDate() + 90));
        this.taskForm.controls['taskDueDate'].patchValue(moreNinetyDays);
      }
    }
    if (this.mode == 'edit') {
      this.getChecklistDetails(this.task_id);
      this.getAttachmentsListForTask(this.task_id);
    }
    if (this.currentFormId && this.mode == 'add' && this.formLinked) {
      this.getAllForms();
    }
    if (this.data?.taskId) {
      this.task_id = this.data.taskId;
    }
    if (this.data?.templateData) {
      this.linkedTemplateObj = {
        fid: this.data.templateData.id || this.data.templateData.vault_user_form_id || '', // Use an empty string or other default if vufid is not present
        form_name: this.data.templateData.form_name || '',
        vault_name: this.data.templateData.vault_name || '',
        section_name: this.data.templateData.organization_section || '',
        profile_image_url: this.data.templateData.profile_image_url || '',
      };
      this.taskForm.controls['vault_user_form_id'].setValue(this.data.templateData.id || this.data.templateData.vault_user_form_id);
    }
  }
  isNotNullEmpty(value) {
    if (value == null || value == undefined || value == '') {
      return true;
    } else {
      return false;
    }
  }

  checkTaskFormValidation(formGroup: UntypedFormGroup) {
    if (formGroup.value['taskDueWhen'] == 'asap') {
      this.is_form_valid = true;
    } else if (formGroup.value['taskDueWhen'] == 'future') {
      if (
        this.isNotNullEmpty(formGroup.value['timeline_finish_date']) ||
        this.isNotNullEmpty(formGroup.value['timeline_start_date']) ||
        this.isNotNullEmpty(formGroup.value['timeline_future_date_is']) ||
        this.isNotNullEmpty(formGroup.value['timeline_period']) ||
        this.isNotNullEmpty(formGroup.value['timeline_period_type'])
      ) {
        this.is_form_valid = false;
      } else {
        this.is_form_valid = true;
      }
    }
    return null;
  }

  ngAfterViewInit() {
    // this.subscription.add(
    //   this.commonService.checklistSidenavToggleSubject.subscribe((data) => {
    //     if (data?.isFormSetupOpen) {
    //       this.setupDrawer = true;
    //       setTimeout(() => {
    //         this.from_data = data;
    //         this.isFormSetupOpen = true;
    //         this.cd.detectChanges();
    //       }, 100);
    //     } else if (data.isLinkTemplateModel) {
    //       this.isLinkTemplateModel = true;
    //       this.from_data = data;
    //       this.cd.detectChanges();
    //       setTimeout(() => {
    //         this.from_data = data;
    //         this.isFormSetupOpen = true;
    //         this.cd.detectChanges();
    //       }, 100);
    //     } else {
    //       this.setupDrawer = false;
    //       this.isFormSetupOpen = false;
    //     }
    //     this.isCustom = false;
    //     this.cd.detectChanges();
    //   })
    // );
    // setTimeout(() => {
    //   this.cd.detectChanges();
    //   this.taskName.nativeElement.focus();
    // }, 0);
  }

  async getChecklistTaskId() {
    const taskId = {
      user_id: this.user.id,
    };
    this.subscription.add(
      this.checklistTaskService.getChecklistTaskId(taskId).subscribe(
        (res) => {
          if (res) {
            this.task_id = res.task_id;
            this.cd.detectChanges();
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }
  getCurrentUserId(): string {
    // This could come from an auth service or session storage
    return 'currentUserId';
  }
  async getChecklistDetails(checklistId) {
    this.subscription.add(
      this.checklistTaskService.getChecklistDetails(checklistId).subscribe(
        (res) => {
          if (res) {
            this.taskDetail = res.data[0];

            // If the task owner is not the same as the logged-in user
            if (this.taskDetail.owner_user_id != this.loginOwnerUserProfile.id) {
              this.isCustom = true;
              this.isTaskCreator = true;
              this.ownerUser = {
                id: this.taskDetail.owner_user_id,
                name: this.taskDetail.first_name + ' ' + this.taskDetail.last_name,
                image: this.taskDetail.form_image_url,
              };
            }

            this.linkedTemplate = this.taskDetail;
            // Update form controls
            this.taskForm.controls['start_date'].setValue(this.taskDetail.start_date);
            this.taskForm.controls['finish_date'].setValue(this.taskDetail.finish_date);
            this.taskForm.controls['timeline_finish_date'].setValue(this.taskDetail.timeline_finish_date);
            this.taskForm.controls['timeline_start_date'].setValue(this.taskDetail.timeline_start_date);
            this.taskForm.controls['timeline_future_date_is'].setValue(this.taskDetail.timeline_future_date_is);
            this.taskForm.controls['timeline_period_type'].setValue(this.taskDetail.timeline_period_type);
            this.taskForm.controls['timeline_period'].setValue(this.taskDetail.timeline_period);
            this.taskForm.controls['taskName'].setValue(this.taskDetail.name);
            this.taskForm.controls['taskDesc'].setValue(this.taskDetail.description);
            this.taskForm.controls['taskDueWhen'].setValue(this.taskDetail.due_when);
            if (this.taskDetail.due_date) this.taskForm.controls['taskDueDate'].setValue(this.taskDetail.due_date);
            this.taskForm.controls['taskStatusProgress'].setValue(this.taskDetail.status_progress);

            // Find the filtered item by shortcut
            let filteredItem: any = this.filteredShortcutList.filter((item: any) => item.id === Number(this.taskDetail.shortcut));
            filteredItem = filteredItem[0];
            this.linkedshortcut = filteredItem;
            // Ensure filteredItem exists before accessing its properties
            if (filteredItem) {
              this.taskForm.controls['shortcut'].setValue(filteredItem.id);
              this.linkedTemplatetypeObj = {
                profile_image_url: filteredItem.image, // Use optional chaining to prevent errors if needed
                shortcut: filteredItem.type,
              };
            }

            // Remove the condition for vufid and always update linkedTemplateObj
            this.taskForm.controls['vault_user_form_id'].setValue(this.taskDetail.vault_user_form_id || '');
            if (this.taskDetail.vufid) {
              this.linkedTemplateObj = {
                fid: this.taskDetail.vufid || '', // Use an empty string or other default if vufid is not present
                form_name: this.taskDetail.form_name || '',
                vault_name: this.taskDetail.vault_name || '',
                section_name: this.taskDetail.section_name || '',
                profile_image_url: this.taskDetail.form_image_url || '',
              };
              if (this.data?.mode == 'edit' && this.taskDetail?.user_id != this.loginOwnerUserProfile?.id) {
                this.linkedTemplate = this.taskDetail;
              } else {
                this.getAllForms();
              }
            }

            // If there's an external link
            if (this.taskDetail.external_link) {
              this.taskForm.controls['hyperLink'].setValue(this.taskDetail.external_link);
              this.taskForm.controls['hyperLinkName'].setValue(this.taskDetail.external_link_name);
              this.linkedHyperlinkObj = {
                external_link: this.taskDetail.external_link,
                external_link_name: this.taskDetail.external_link_name,
              };
            }

            // If there are repeat task details
            if (this.taskDetail.repeat_after_duration && this.taskDetail.repeat_after_period) {
              this.taskForm.controls['repeat_after_duration'].setValue(this.taskDetail.repeat_after_duration);
              this.taskForm.controls['repeat_after_period'].setValue(this.taskDetail.repeat_after_period);
              this.taskForm.controls['repeat_task'].setValue(true);
            }

            this.loadHyperlink = false;
            this.cd.detectChanges();
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  async getAttachmentsListForTask(checklistTaskId) {
    this.subscription.add(
      this.checklistTaskService.getAttachmentsListForTask(this.user.id, checklistTaskId).subscribe(
        (res) => {
          if (res) {
            this.attachedItems = 'attachment';
            this.files = res.files;
            if (res.files.length > 0) {
              this.attachedAdded = true;
            }
            this.cd.detectChanges();
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  async getExternalLinkName(url: string) {
    const payload = {
      link: url,
    };
    this.subscription.add(
      this.checklistTaskService.getExternalLinkName(payload).subscribe(
        (res) => {
          this.taskForm.controls['hyperLinkName'].patchValue(res[0]?.title);
          if (this.mode == 'add') {
            this.linkedHyperlinkObj = {
              external_link: this.taskForm.controls['hyperLink'].value,
              external_link_name: this.taskForm.controls['hyperLinkName'].value,
            };
            this.loadHyperlink = false;
          }
          if (this.mode == 'edit') this.updateChecklistTask('hyperlink');
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  getAllForms() {
    this.subscription.add(
      this.checklistTaskService.getAllForms(this.user.id).subscribe(
        (result: any) => {
          let tempStore = [];
          result.data.forEach((element, index) => {
            let tempEllemt = {
              ...element,
              name: '',
            };
            tempEllemt.name = element.form_name;
            tempStore.push(tempEllemt);
          });
          this.formsList = tempStore;
          this.linkedTemplate = this.formsList.filter((item) => item.id == this.taskDetail.vault_user_form_id);
          this.linkedTemplate = this.linkedTemplate[0];
          if (this.currentFormId && this.mode == 'add' && this.formLinked) {
            const linkedForm = this.formsList.filter((item) => item.id == this.currentFormId);

            this.taskForm.controls['vault_user_form_id'].patchValue(linkedForm[0].id);
            this.linkedTemplateObj = {
              fid: linkedForm[0].fid,
              form_name: linkedForm[0].form_name,
              vault_name: linkedForm[0].vault_name,
              section_name: linkedForm[0].section_name,
              profile_image_url: linkedForm[0].profile_image_url,
            };
            this.addTemplate = false;
            this.addTemplatetype = false;
            this.templatetypeAdded = true;
            this.templateAdded = true;
            this.showDropDown = false;
          }
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  createChecklistTask() {
    let formatedDate = this.taskForm.controls['taskDueDate'].value ? moment(this.taskForm.controls['taskDueDate'].value).format('YYYY-MM-DD') : null;
    let taskData = {
      id: this.task_id,
      name: this.taskForm.controls['taskName'].value != '' ? this.taskForm.controls['taskName'].value : 'Untitled Task',
      ...(this.taskForm.controls['taskDesc'].value && { description: this.taskForm.controls['taskDesc'].value }),
      ...(this.taskForm.controls['hyperLink'].value && { external_link: this.taskForm.controls['hyperLink'].value ?? '' }),
      ...(this.taskForm.controls['hyperLink'].value && { external_link_name: this.taskForm.controls['hyperLinkName'].value ?? '' }),
      due_when: this.taskForm.controls['taskDueWhen'].value,
      ...(this.taskForm.controls['taskDueDate'].value && { due_date: formatedDate }),
      ...(this.taskForm.controls['taskDueDate'].value &&
        this.taskForm.controls['repeat_task'].value && { repeat_after_duration: this.taskForm.controls['repeat_after_duration'].value }),
      ...(this.taskForm.controls['taskDueDate'].value &&
        this.taskForm.controls['repeat_task'].value && { repeat_after_period: this.taskForm.controls['repeat_after_period'].value }),
      status_progress: this.taskForm.controls['taskStatusProgress'].value,
      ...(this.taskForm.controls['vault_user_form_id'].value && { vault_user_form_id: this.taskForm.controls['vault_user_form_id'].value }),
      owner_user_id: this.isCustom ? this.ownerUser.id : this.loginOwnerUserProfile.id,
      start_date: this.taskForm.controls.start_date.value,
      finish_date: this.taskForm.controls.finish_date.value,
      timeline_start_date: this.taskForm.controls.timeline_start_date.value,
      timeline_finish_date: this.taskForm.controls.timeline_finish_date.value,
      timeline_future_date_is: this.taskForm.controls.timeline_future_date_is.value,
      timeline_period: this.taskForm.controls.timeline_period.value,
      timeline_period_type: this.taskForm.controls.timeline_period_type.value,
      shortcut: this.taskForm.controls.shortcut.value,
    };

    if (this.taskForm.controls['taskDueDate'].value == 'asap') {
      delete taskData['timeline_start_date'];
      delete taskData['timeline_finish_date'];
      delete taskData['timeline_future_date_is'];
      delete taskData['timeline_period_type'];
      delete taskData['timeline_period'];
    } else if (this.taskForm.controls['taskDueDate'].value == 'future') {
      delete taskData['start_date'];
      delete taskData['finish_date'];
    }

    if (!this.taskForm.valid) {
      return;
    }
    this.subscription.add(
      this.checklistTaskService.createChecklistTask(taskData).subscribe(
        (res) => {
          if (res.status) {
            this.toastr.success('Checklist task created');
            this.isCustom = false;
            this.dialogRef.close();
            this.cd.detectChanges();
          }
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  updateChecklistTask(type) {
    let formatedDate = this.taskForm.controls['taskDueDate'].value ? moment(this.taskForm.controls['taskDueDate'].value).format('YYYY-MM-DD') : null;
    const taskData = {
      id: this.task_id,
      ...(type == 'name' && { name: this.taskForm.controls['taskName'].value }),
      ...(type == 'description' && { description: this.taskForm.controls['taskDesc'].value }),
      ...(type == 'hyperlink' && {
        external_link: this.taskForm.controls['hyperLink'].value ?? null,
      }),
      ...(type == 'hyperlink' && { external_link_name: this.taskForm.controls['hyperLinkName'].value ?? null }),
      // ...((type == 'start_date' || type == 'taskDueWhen') && { start_date: this.taskForm.controls['start_date'].value }),
      // ...((type == 'finish_date' || type == 'taskDueWhen') && { finish_date: this.taskForm.controls['finish_date'].value  }),
      // ...((type == 'timeline_start_date' || type == 'taskDueWhen') && { timeline_start_date: this.taskForm.controls['timeline_start_date'].value }),
      // ...((type == 'timeline_finish_date' || type == 'taskDueWhen') && { timeline_finish_date: this.taskForm.controls['timeline_finish_date'].value }),
      // ...((type == 'timeline_future_date_is' || type == 'taskDueWhen') && { timeline_future_date_is: this.taskForm.controls['timeline_future_date_is'].value }),
      // ...((type == 'timeline_period_type' || type == 'taskDueWhen') && { timeline_period_type: this.taskForm.controls['timeline_period_type'].value }),
      // ...((type == 'timeline_period' || type == 'taskDueWhen') && { timeline_period: this.taskForm.controls['timeline_period'].value }),
      ...(type == 'taskStatusProgress' && { status_progress: this.taskForm.controls['taskStatusProgress'].value }),
      ...(type == 'shortcut' && { shortcut: this.taskForm.controls['shortcut'].value }),
      ...(type == 'template' && { vault_user_form_id: this.taskForm.controls['vault_user_form_id'].value }),
      ...(type == 'owner' && { owner_user_id: this.isCustom ? this.ownerUser.id : this.loginOwnerUserProfile.id }),
      ...(type == 'taskDueWhen' &&
        this.taskForm.controls['taskDueWhen'].value === 'asap' && {
          due_when: this.taskForm.controls['taskDueWhen'].value,
          start_date: this.taskForm.controls['start_date'].value,
          finish_date: this.taskForm.controls['finish_date'].value,
        }),
      ...(type == 'taskDueWhen' &&
        this.taskForm.controls['taskDueWhen'].value === 'future' && {
          due_when: this.taskForm.controls['taskDueWhen'].value,
          timeline_start_date: this.taskForm.controls['timeline_start_date'].value,
          timeline_finish_date: this.taskForm.controls['timeline_finish_date'].value,
          timeline_future_date_is: this.taskForm.controls['timeline_future_date_is'].value,
          timeline_period: this.taskForm.controls['timeline_period'].value,
          timeline_period_type: this.taskForm.controls['timeline_period_type'].value,
        }),
    };
    this.isEventInProgress = true;
    this.subscription.add(
      this.checklistTaskService.updateChecklistTask(taskData).subscribe(
        (res) => {
          this.getChecklistDetails(res.id);
          this.isEventInProgress = false;

          // this.sidenav.close();
          this.cd.detectChanges();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }
  updateTask() {
    if (this.mode == 'edit') {
      this.addDescription();
      if (this.taskForm.controls['taskDueWhen'].value === 'asap') {
        this.updateChecklistTask('taskDueWhen');
      } else if (this.taskForm.controls['taskDueWhen'].value === 'future') {
        this.updateChecklistTask('taskDueWhen');
      }
      this.toastr.success('Checklist task updated');

      this.dialogRef.close();
    }
  }
  deleteChecklistTask() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete item',
        materialIcon: 'delete',
        text: 'This action cannot be undone, are you sure you want to delete this item?',
        proceedTitle: 'Delete',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.checklistTaskService.deleteChecklistTask(this.taskId ?? this.task_id).subscribe((res) => {
              if (res) {
                this.toastr.success(`Checklist task deleted successfully!`);
                this.dialogRef.close();
                this.cd.detectChanges();
              }
            })
          );
        }
      })
    );
  }

  uploadFile(event) {
    const files = event.target.files;
    if (files) {
      this.attachedItems = 'Attachments';
      for (let index = 0; index < files.length; index++) {
        const element = files[index];
        const extension = element['name'].split('?')[0].split('.').pop();
        if (this.FileUploadedLimitExtension.findIndex((item) => item == extension.toUpperCase()) == -1) {
          this.toastr.error(`This type of file is not supported : ${element['type']}`);
        } else {
          this.uploadAttachement(element['name'], element['size'], element, this.files.length + index);
          this.cd.detectChanges();
        }
      }
    }
  }

  uploadAttachement(fileName, size, file, currentIndex) {
    const data = {
      checklist_task_id: this.mode == 'edit' ? this.taskDetail.id : this.task_id,
      user_id: this.user.id,
      name: fileName,
      file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
      display_file_name: fileName,
      size: size,
      type: file.type,
    };

    this.subscription.add(
      this.checklistTaskService.createUploadUrl(data).subscribe(async (res) => {
        if (res['uploadLimitExceeded']) {
          this.toastr.error(`All the storage space in your has been used`);
          return;
        }
        this.files.push({
          status: 'Uploading',
          file_name_without_extesion: fileName.split('.').slice(0, -1).length == 0 ? fileName : fileName.split('.').slice(0, -1).join('.'),
          display_file_name: fileName,
          progressbar: 0,
          name: fileName,
          created_at: res['created_at'],
          id: res['id'],
          delete_upload_path: res['upload_path'],
        });
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = (progEvent: ProgressEvent) => {
          if (progEvent.lengthComputable) {
            const uploadedSoFar = (progEvent.loaded / progEvent.total) * 100;
            this.files[currentIndex]['progressbar'] = Math.trunc(uploadedSoFar);
            this.cd.detectChanges();
          }
        };
        // const encryption_key = this.cryptoService.generateEncryptionKey(this.currentUserSecurity.public_key, null, null).plain;
        // const encryptedFile = await this.cryptoService.encryptFile(file, this.currentUserSecurity.public_key, encryption_key, null, null);
        const blobData = new Blob([file], { type: 'application/json' });
        xhr.open('PUT', res['upload_url'], true);
        xhr.setRequestHeader('Content-Type', file.type);
        xhr.send(blobData);
        xhr.onload = () => {
          if (xhr.readyState === xhr.DONE) {
            const data = {
              display_file_name: fileName,
              id: this.files[currentIndex]['id'],
              status: 'uploaded',
            };
            this.subscription.add(
              this.checklistTaskService.updateUploadStatus(data).subscribe(
                (res) => {
                  this.files[currentIndex]['status'] = 'uploaded';
                  this.cd.detectChanges();
                },
                (error) => {
                  this.toastr.error('Error uploading File');
                }
              )
            );
            this.cd.detectChanges();
          } else {
            this.toastr.error('6 Error uploading File');
          }
        };
        (error: any) => {
          this.toastr.error('Error creating upload url');
        };
      })
    );
  }

  deleteAttachment(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.checklistTaskService.deleteUploadedAttachment(this.user.id, id).subscribe(
              (res) => {
                this.files.splice(index, 1);
                if (this.files.length == 0) {
                  this.attachedItems = '';
                }
                this.toastr.success(`${display_file_name} deleted`);
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error('Error deleting File');
              }
            )
          );
        }
      })
    );
  }

  downloadAttachment(id, name, isStop, is_form_download = false) {
    this.subscription.add(
      this.checklistTaskService.downloadAttachment(this.user.id, id).subscribe((res) => {
        const file = res.files.data;
        // const decryption_key = this.cryptoService.decryptWithPassword(file.key, environment.encryption_mask_id);
        // const decrypted_file = this.cryptoService.decryptFile(file.data, decryption_key);
        const fileData = new Uint8Array(file.Body.data);
        const blob = new Blob([fileData.buffer], { type: file.ContentType });
        fileSaver.saveAs(blob, name);
        this.cd.detectChanges();
      })
    );
  }

  viewAttachedFile(fileId, i, fileName) {
    this.subscription.add(
      this.checklistTaskService.downloadAttachment(this.user.id, fileId).subscribe((res) => {
        const file = res.files.data;
        // const decryption_key = this.cryptoService.decryptWithPassword(file.key, environment.encryption_mask_id);
        // const decrypted_file = this.cryptoService.decryptFile(file.data, decryption_key);
        const fileData = new Uint8Array(file.Body.data);
        if (this.checkIfImage(fileName)) {
          this.urlLinks[i] = `data:image/${fileName.split('.').pop()};base64,${toBase64(fileData)}`;
        } else {
          this.urlLinks[i] = { data: fileData };
        }

        setTimeout(() => {
          const iframe = document.getElementById('iframe-doc-viewer');
          if (iframe) {
            this.iframeLoaded = true;
          }
        }, 500);

        this.cd.markForCheck();
      })
    );
  }

  checkIfImage(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (
        fileNameFormated.includes('svg') ||
        fileNameFormated.includes('jpeg') ||
        fileNameFormated.includes('png') ||
        fileNameFormated.includes('jpg') ||
        fileNameFormated.includes('giff')
      ) {
        return true;
      }
      return false;
    }
    return false;
  }

  checkIfPdf(fileName) {
    if (fileName != undefined) {
      const fileNameFormated = fileName.toLowerCase();
      if (fileNameFormated.includes('pdf')) {
        return true;
      }
      return false;
    }
    return false;
  }

  hideDocViewer(index) {
    this.urlLinks[index] = '';
    this.iframeLoaded = false;
  }

  materialIconName(element) {
    if (element.display_file_name == undefined) {
      return 'doc';
    }
    let type = element.display_file_name.replace(/^.*\./, '') != element.display_file_name ? element.display_file_name.replace(/^.*\./, '') : '';
    if (type == '') {
      return 'doc';
    } else {
      return type.toLowerCase();
    }
  }

  onEditDescription() {
    if (this.mode == 'edit' && this.taskForm.controls['taskStatusProgress'].value == 'complete') {
      this.taskForm.controls['taskDesc'].disable();
      return;
    } else {
      this.taskForm.controls['taskDesc'].enable();
    }
    this.showEditorMenu = true;
    this.cd.detectChanges();
  }

  addDescription() {
    this.updateChecklistTask('description');
    this.showEditorMenu = false;
    this.cd.detectChanges();
  }

  removeAddedDescription() {
    this.taskForm.controls['taskDesc'].patchValue('');
    this.updateChecklistTask('description');
    this.showEditorMenu = false;
    this.cd.detectChanges();
  }

  addTemplateForForm() {
    this.searchText = '';
    setTimeout(() => {
      this.cd.detectChanges();
      this.templateSearchInput.nativeElement.focus();
    }, 0);
    this.addTemplate = !this.addTemplate;
    this.addTemplatetype = false;
    this.templateAdded = false;
    this.templatetypeAdded = false;
    this.showDropDown = true;
    this.formLinked = false;
    this.getAllForms();
    this.cd.detectChanges();
  }
  addTemplateForFormType() {
    this.filteredShortcutList = this.shortcutlist;
    this.searchTextType = '';
    setTimeout(() => {
      this.cd.detectChanges();
      this.templateSearchInput.nativeElement.focus();
    }, 0);
    this.addTemplatetype = !this.addTemplatetype;
    this.addTemplate = false;
    this.templateAdded = false;
    this.templatetypeAdded = false;
    this.showDropDown = true;
    this.formLinked = false;
    // this.getAllForms();
    this.cd.detectChanges();
  }
  addHyperlinkForTask() {
    this.addHyperlink = !this.addHyperlink;
    setTimeout(() => {
      this.cd.detectChanges();
      this.hyperLink.nativeElement.focus();
    }, 0);
  }

  clearAddedShortcut() {
    this.addTemplatetype = false;
    this.filteredShortcutList = this.shortcutlist;
    this.searchTextType = '';
    if (this.taskForm.controls['shortcut'].value) {
      this.showDropDown = false;
      this.templatetypeAdded = false;
      this.linkedTemplatetypeObj = null;

      // this.taskForm.controls['vault_user_form_id'].patchValue(null);
    }
    this.showDropDown = false;
    this.cd.detectChanges();
  }
  clearAddedTemplate() {
    this.addTemplate = false;
    this.searchText = '';
    if (this.taskForm.controls['vault_user_form_id'].value) {
      this.showDropDown = false;
      this.templateAdded = false;
      this.linkedTemplateObj = null;
      // this.taskForm.controls['vault_user_form_id'].patchValue(null);
    }
    this.showDropDown = false;
    this.cd.detectChanges();
  }

  removeAddedTemplatetype() {
    this.taskForm.controls['shortcut'].setValue(null);
    this.updateChecklistTask('shortcut');
    this.addTemplatetype = false;
    this.showDropDown = false;
    this.templatetypeAdded = false;
    this.linkedTemplatetypeObj = null;
    this.cd.detectChanges();
    this.filteredShortcutList = this.shortcutlist;
    this.searchTextType = '';
  }
  removeAddedTemplate() {
    this.taskForm.controls['vault_user_form_id'].setValue(null);
    this.updateChecklistTask('template');
    this.addTemplate = false;
    this.showDropDown = false;
    this.templateAdded = false;
    this.linkedTemplateObj = null;
    this.cd.detectChanges();
    this.searchText = '';
  }

  clearAddedHyperlink() {
    this.taskForm.controls['hyperLink'].setValue('');
    this.addHyperlink = false;
  }

  removeAddedHyperlink() {
    this.taskForm.controls['hyperLink'].patchValue(null);
    this.taskForm.controls['hyperLinkName'].patchValue(null);
    if (this.mode == 'edit') this.updateChecklistTask('hyperlink');
    this.addHyperlink = false;
    this.linkedHyperlinkObj = null;
    this.cd.detectChanges();
  }

  async saveHyperlink() {
    if (!this.isValidUrl()) {
      this.taskForm.controls['hyperLink'].setErrors({});
      this.cd.detectChanges();
      return;
    }
    this.loadHyperlink = true;
    await this.getExternalLinkName(this.taskForm.controls['hyperLink'].value);
    this.addHyperlink = false;
    this.cd.detectChanges();
  }

  removeAddedOwner() {}

  searchTemplate(text) {
    this.searchText = text;
    this.searchTextType = text;
    this.showDropDown = true;
    this.formLinked = false;
    this.cd.detectChanges();
  }
  searchTemplatetype(searchValue: string): void {
    this.filteredShortcutList = this.shortcutlist.filter((item) => item.type.toLowerCase().includes(searchValue.toLowerCase()));
  }
  selectFormForTypeTask(item) {
    this.taskForm.controls['shortcut'].patchValue(item.id);
    this.linkedshortcut = item;
    if (this.mode == 'add') {
      this.linkedTemplatetypeObj = { profile_image_url: item?.image, shortcut: item.type };
    } else if (this.mode == 'edit') {
      this.updateChecklistTask('shortcut');
    }
    this.addTemplate = false;
    this.addTemplatetype = false;
    this.templateAdded = false;
    this.templatetypeAdded = true;
    this.showDropDown = false;
    this.cd.detectChanges();
  }
  selectFormForTask(item) {
    this.taskForm.controls['vault_user_form_id'].patchValue(item.id);
    this.linkedTemplate = item;
    // if (this.mode == 'add') {
    //   this.checkFormHasAccess(item);
    //   this.linkedTemplateObj = {
    //     fid: item.fid,
    //     form_name: item.form_name,
    //     vault_name: item.vault_name,
    //     section_name: item.section_name,
    //     profile_image_url: item?.profile_image_url,
    //   };
    //   this.addTemplate = false;
    //   this.addTemplatetype = false;
    //   this.templateAdded = true;
    //   this.templatetypeAdded = false;
    //   this.showDropDown = false;
    // }
    this.showDropDown = true;
    this.checkFormHasAccess(item);
    this.cd.detectChanges();
  }

  changeOwner() {
    this.ownerlist = true;
  }
  handleClose(event) {
    if (event.isSuccess) {
      this.ownerlist = false;
      this.isCustom = this.loginOwnerUserProfile.id == event.item.id ? false : true;
      this.ownerUser = event.item;
      if (this.mode == 'edit') {
        this.updateChecklistTask('owner');
      }
      this.cd.detectChanges();
    }
  }
  onAttachedAddedChange(newValue: boolean) {
    this.attachedAdded = newValue;
  }

  checkFormHasAccess(item) {
    this.AccessTotemplate = true;
    if (this.isCustom && this.ownerUser.id != this.loginOwnerUserProfile.id) {
      this.subscription.add(
        this.documentService.checkUserHasFormAccess(this.ownerUser.id, [item.id]).subscribe((res) => {
          this.AccessTotemplate = false;
          if (!res.access) {
            this.AccessTotemplate = false;
            this.getAccessTotemplate = true;
            // const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
            //   width: '400px',
            //   data: {
            //     title: `Permission Error`,
            //     materialIcon: 'delete',
            //     text: 'The task owner does not have permission to this template',
            //     proceedTitle: 'Grant',
            //   },
            // });

            // this.subscription.add(
            //   dialogRef.afterClosed().subscribe((confirmation) => {
            //     if (confirmation) {
            //       const request = {
            //         formids: [item.id],
            //         user_id: this.ownerUser.id,
            //       };
            //       this.subscription.add(
            //         this.documentService.grantPermission(request).subscribe((res) => {
            //           if ((res.status = 'success')) {
            //             this.isCustom = this.loginOwnerUserProfile.id == this.ownerUser.id ? false : true;
            //             if (this.mode == 'edit') {
            //               this.updateChecklistTask('template');
            //             }
            //           }
            //         })
            //       );
            //     } else {
            //       this.mode == 'edit' ? this.removeAddedTemplate() : this.clearAddedTemplate();
            //     }
            //   })
            // );
          } else {
            if (this.mode == 'edit') {
              this.AccessTotemplate = false;
              this.getAccessTotemplate = false;
              this.addTemplate = false;
              this.addTemplatetype = false;
              this.templateAdded = true;
              this.templatetypeAdded = false;
              this.showDropDown = false;
              this.updateChecklistTask('template');
            }
            this.linkedTemplateObj = {
              fid: item.fid,
              form_name: item.form_name,
              vault_name: item.vault_name,
              section_name: item.section_name,
              profile_image_url: item?.profile_image_url,
            };
            this.showDropDown = false;
          }
          this.cd.detectChanges();
        })
      );
    } else {
      this.linkedTemplateObj = {
        fid: item.fid,
        form_name: item.form_name,
        vault_name: item.vault_name,
        section_name: item.section_name,
        profile_image_url: item?.profile_image_url,
      };
      this.AccessTotemplate = false;
      this.getAccessTotemplate = false;
      this.addTemplate = false;
      this.addTemplatetype = false;
      this.templateAdded = true;
      this.templatetypeAdded = false;
      this.showDropDown = false;
      if (this.mode == 'edit') {
        this.updateChecklistTask('template');
      }
    }
    this.cd.detectChanges();
  }
  shareAccesss(item) {
    if (this.getAccessTotemplate) {
      this.AccessTotemplate = false;
      const request = {
        formids: [item.id],
        user_id: this.ownerUser.id,
      };
      this.subscription.add(
        this.documentService.grantPermission(request).subscribe((res) => {
          this.AccessTotemplate = false;
          if ((res.status = 'success')) {
            this.addTemplate = false;
            this.showDropDown = false;
            this.AccessTotemplate = false;
            this.getAccessTotemplate = false;
            this.addTemplatetype = false;
            this.templateAdded = true;
            this.templatetypeAdded = false;
            this.linkedTemplateObj = {
              fid: item.fid,
              form_name: item.form_name,
              vault_name: item.vault_name,
              section_name: item.section_name,
              profile_image_url: item?.profile_image_url,
            };
            this.isCustom = this.loginOwnerUserProfile.id == this.ownerUser.id ? false : true;
            if (this.mode == 'edit') {
              this.updateChecklistTask('template');
            }
            this.cd.detectChanges();
          }
        })
      );
    } else {
      this.mode == 'edit' ? this.removeAddedTemplate() : this.clearAddedTemplate();
    }
  }
  cancelAccess() {
    this.addTemplate = false;
    this.addTemplatetype = false;
    this.templateAdded = false;
    this.templatetypeAdded = false;
    this.showDropDown = false;
    this.getAccessTotemplate = false;
    this.mode == 'edit' ? this.removeAddedTemplate() : this.clearAddedTemplate();
  }
  openFormShortcut(item) {
    this.addVaultShortcut = true;
  }
  closenavshortcut() {
    this.addVaultShortcut = false;
  }
  openForm(tempDetalis) {
    if (this.data?.mode == 'edit' && this.taskDetail?.user_id != this.loginOwnerUserProfile?.id) {
      const file = {
        form_name: tempDetalis.form_name,
        formid: tempDetalis.id,
        id: tempDetalis.vault_user_form_id,
        percent_complete: null,
        total: '',
        total_created: '',
        user_id: tempDetalis.user_id,
        vault_form_id: tempDetalis.vault_form_id,
        vault_id: tempDetalis.vault_id,
        vfid: tempDetalis.vfid,
        vufid: tempDetalis.vufid,
      };
      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: {
          file,
          mode: 'edit',
          isintelligent: false,
          isfileListLoad: true,
          isFromChecklist: true,
          isReport: true,
        },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
    } else {
      const file = {
        form_name: tempDetalis.form_name,
        formid: tempDetalis.id,
        id: tempDetalis.id,
        percent_complete: null,
        total: '',
        total_created: '',
        user_id: tempDetalis.user_id,
        vault_form_id: tempDetalis.vault_form_id,
        vault_id: tempDetalis.vault_id,
        vfid: tempDetalis.vfid,
        vufid: tempDetalis.vufid,
      };

      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: {
          file,
          mode: 'edit',
          isintelligent: false,
          isfileListLoad: true,
          isFromChecklist: true,
          isReport: true,
        },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
    }

    // }
  }
  addAttachment(item) {
    const dialogRef = this.dialog.open(CreateAttachemntPopupComponent, {
      height: '100%',
      width: '735px',
      maxWidth: '90%',
      data: {
        currentFormId: '',
        origin: this.origin,
        new: true,
        hide_create_reminder: true,
        showToggle: false,
        task_id: this.task_id,
        manageSecuritykey: null,
        isSecurityKeyAdded: false,
        sub_type: 'Task',
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        if (res?.nothingChange) {
          return;
        }
        this.is_reload = true;
        this.attachedAdded = true;
        setTimeout(() => {
          this.is_reload = false;
          this.cd.detectChanges();
        }, 1000);
        this.cd.detectChanges();
      })
    );
  }
  getFormData(id) {
    if (this.stateObject && this.stateObject.forms) {
      return this.stateObject.forms.filter((form) => form.id == id);
    }
  }
  checkUrlProtocol(url) {
    if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
      url = 'https://' + url;
    }
    return url;
  }

  isValidUrl() {
    let url = this.checkUrlProtocol(this.taskForm.controls['hyperLink'].value);
    const urlPattern = /(ftp|http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    return urlPattern.test(url);
  }

  updateDuewhen() {
    if (this.taskForm.controls['taskDueWhen'].value == 'asap') {
      this.taskForm.controls['taskDueDate'].patchValue(null);
      this.taskForm.controls['repeat_task'].patchValue(false);
      this.taskForm.controls['repeat_after_duration'].patchValue(null);
      this.taskForm.controls['repeat_after_period'].patchValue(null);
      if (this.mode == 'edit') this.updateChecklistTask('dueWhen');
      this.cd.detectChanges();
    }
  }

  changeRepeatTask() {
    if (!this.taskForm.controls['repeat_task'].value) {
      this.taskForm.controls['repeat_after_duration'].patchValue(null);
      this.taskForm.controls['repeat_after_period'].patchValue(null);
      this.updateChecklistTask('dueWhen');
    } else {
      this.taskForm.controls['repeat_after_duration'].patchValue(this.repeateAfterDuration[0]);
      this.taskForm.controls['repeat_after_period'].patchValue(this.repeateAfterPeriod[0].value);
      this.updateChecklistTask('dueWhen');
    }
  }

  openLinkInAnotherTab(url) {
    window.open(this.checkUrlProtocol(url), '_blank');
  }

  afterLoadComplete(event) {
    this.loaderService.hide();
  }

  onProgress(event) {
    this.loaderService.show();
  }

  pageRendered(event) {}

  closeSideNav() {
    this.isCustom = false;
    this.closeSidebarEmitter.emit(true);
    this.dialogRef.close();
  }

  closeSideNavDiv(event) {
    let path = event.path || (event.composedPath && event.composedPath());
    if (path[0].className.includes('mat-drawer-backdrop')) {
      this.closeSideNav();
    }
  }
  ngOnDestroy() {
    this.editor.destroy();
    this.subscription?.unsubscribe();
  }
  handleDateChange(value, control) {
    // this.taskForm.controls[control].patchValue(value);
  }
  handleDateChange2(value, control) {
    this.taskForm.controls[control].patchValue(value);
  }
  get startDateValue() {
    return this.taskForm.controls['timeline_start_date'].value;
  }
  get endDateValue() {
    return this.taskForm.controls['timeline_finish_date'].value;
  }
}
